// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"5231bc46","110":"95a8d74d"}[chunkId] + ".chunk.css";
};